export default
function thinkaloud(state = {

}, action){
  switch(action.type) {
    case 'GET_LINEDATA':
      return Object.assign({}, state, {
        lineData: action.lineData
      });
    case 'NEXT_LINE':
      return Object.assign({}, state, {
        lineOrder: state.lineOrder + 1
      });
    case 'SELECT_LINE':
      return Object.assign({}, state, {
        activeLine: action.activeLine
      });
    case 'START_THINKALOUD':
      return Object.assign({}, state, {
        lineOrder: 1, running: true
      });
    case 'END_THINKALOUD':
      return Object.assign({}, state, {
        activeLine: null, running: false, lineOrder: null
      });
    case 'SET_TOOLTIP':
      return Object.assign({}, state, {
        tooltip: action.tooltip
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/thinkaloud.js